// extracted by mini-css-extract-plugin
module.exports = {"parent":"ParentBox_parent__BsX1K","input":"ParentBox_input__G15LP","row":"ParentBox_row__1Qzux"};